/**
 * Opens/closes a single shared native <dialog> for Relic event cards.
 *
 * Markup hooks (queried by data-attribute):
 *   [data-relic-events]              — section wrapper; click delegation root
 *   [data-relic-event-modal-open]    — trigger button (aria-controls → dialog id)
 *   [data-relic-event-modal-source]  — hidden per-card content source (on button via data-relic-event-modal-source)
 *   [data-relic-event-modal]         — shared <dialog> element
 *   [data-relic-event-modal-close]   — close button inside dialog
 *   [data-relic-event-modal-title]   — title field (in source + dialog)
 *   [data-relic-event-modal-date-day] — day field (in source + dialog)
 *   [data-relic-event-modal-date-month] — month field (in source + dialog)
 *   [data-relic-event-modal-date-year] — year field (in source + dialog)
 *   [data-relic-event-modal-body]    — richtext body field (in source + dialog)
 *   [data-relic-event-modal-links]   — calendar links markup (in source only; injected into dialog body)
 */
function populateEventModal(dialog, source) {
  const title = source.querySelector('[data-relic-event-modal-title]');
  const dateDay = source.querySelector('[data-relic-event-modal-date-day]');
  const dateMonth = source.querySelector('[data-relic-event-modal-date-month]');
  const dateYear = source.querySelector('[data-relic-event-modal-date-year]');
  const body = source.querySelector('[data-relic-event-modal-body]');
  const links = source.querySelector('[data-relic-event-modal-links]');

  const dialogTitle = dialog.querySelector('[data-relic-event-modal-title]');
  const dialogDateDay = dialog.querySelector('[data-relic-event-modal-date-day]');
  const dialogDateMonth = dialog.querySelector('[data-relic-event-modal-date-month]');
  const dialogDateYear = dialog.querySelector('[data-relic-event-modal-date-year]');
  const dialogBody = dialog.querySelector('[data-relic-event-modal-body]');

  if (!title || !dateDay || !dateMonth || !dateYear || !body) return false;
  if (!dialogTitle || !dialogDateDay || !dialogDateMonth || !dialogDateYear || !dialogBody) return false;

  dialogTitle.textContent = title.textContent;
  dialogDateDay.textContent = dateDay.textContent;
  dialogDateMonth.textContent = dateMonth.textContent;
  dialogDateYear.textContent = dateYear.textContent;
  dialogBody.innerHTML = body.innerHTML;

  const linkMarkup = links?.innerHTML.trim();
  if (linkMarkup) {
    const firstParagraph = dialogBody.querySelector('p:first-child');
    if (firstParagraph) {
      firstParagraph.insertAdjacentHTML('afterend', linkMarkup);
    } else {
      dialogBody.insertAdjacentHTML('afterbegin', linkMarkup);
    }
  }

  return true;
}

function initRelicEventModals() {
  document.querySelectorAll('[data-relic-events]').forEach((section) => {
    if (section.dataset.relicEventModalsInit) return;
    section.dataset.relicEventModalsInit = 'true';

    section.addEventListener('click', (event) => {
      const openTrigger = event.target.closest('[data-relic-event-modal-open]');
      if (openTrigger) {
        const dialogId = openTrigger.getAttribute('aria-controls');
        const sourceId = openTrigger.getAttribute('data-relic-event-modal-source');
        const dialog = dialogId ? document.getElementById(dialogId) : null;
        const source = sourceId ? document.getElementById(sourceId) : null;

        if (dialog && source && populateEventModal(dialog, source)) {
          event.preventDefault();
          dialog.showModal();
        }
        return;
      }

      const closeTrigger = event.target.closest('[data-relic-event-modal-close]');
      if (closeTrigger) {
        const dialog = closeTrigger.closest('[data-relic-event-modal]');
        dialog?.close();
      }
    });
  });

  document.querySelectorAll('[data-relic-event-modal]').forEach((dialog) => {
    if (dialog.dataset.relicEventModalBackdropInit) return;
    dialog.dataset.relicEventModalBackdropInit = 'true';

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        dialog.close();
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRelicEventModals);
} else {
  initRelicEventModals();
}

document.addEventListener('shopify:section:load', initRelicEventModals);
